<template>
  <div class="px-4 pb-4">
    <div
      class="pt-6"
      style="font-size: 13px;font-weight: bold;"
    >
      バックアップファイルの作成方法は
      <v-icon>mdi-open-in-app</v-icon>
      <a
        href="https://syosetu.com/man/novelbackup/"
        target="_blank"
      >小説家になろう様のマニュアル</a> をご確認ください。
    </div>
    <div style="font-size: 13px;color:red;">
      ※バックアップのファイルは「UTF-8」の改行コード「CR+LF」で作成をお願いします。それ以外は未対応です。
    </div>
    <div
      class="pt-4"
      style="font-size: 13px;"
    >
      <ListIcon
        style="color:var(--v-secondary-base) ;width:6px;height:7px"
        class="mr-1"
      />
      保存方法の選択
    </div>
    <v-radio-group v-model="saveType">
      <v-radio
        key="0"
        :value="0"
      >
        <template v-slot:label>
          <div
            style="font-size: 13px;"
            class="text--primary"
          >
            新しく小説を作成して保存
          </div>
        </template>
      </v-radio>
      <v-radio
        key="1"
        :value="1"
      >
        <template v-slot:label>
          <div
            style="font-size: 13px;"
            class="text--primary"
          >
            既存の小説内に保存
          </div>
        </template>
      </v-radio>
    </v-radio-group>

    <v-container
      v-if="saveType==1"
      class="ma-0 pa-0"
    >
      <div
        class="pt-3"
        style="font-size: 13px;"
      >
        <ListIcon
          style="color:var(--v-secondary-base) ;width:6px;height:7px"
          class="mr-1"
        />
        保存先の小説
      </div>
      <v-select
        v-model="selectNovel"
        :items="novels"
        class="hide-details"
        filled
        item-text="name"
        return-object
      />
    </v-container>

    <v-container
      v-if="saveType==0"
      class="ma-0 pa-0"
    >
      <div
        class="pt-3"
        style="font-size: 13px;"
      >
        <ListIcon
          style="color:var(--v-secondary-base) ;width:6px;height:7px"
          class="mr-1"
        />
        小説のタイトル
      </div>
      <v-text-field
        v-model="name"
        background-color="background"
        :maxlength="inputLength.title"
        class="mt-4 mb-0 hide-details mb-4"
        dense
        flat
        label="小説のタイトルを入力"
        single-line
        solo
        style="border-radius: 0px"
      />
      <div
        class="pt-3"
        style="font-size: 13px;"
      >
        <ListIcon
          style="color:var(--v-secondary-base) ;width:6px;height:7px"
          class="mr-1"
        />
        投稿先サイト
      </div>
      <div
        class="pa-2"
        :style="`background-color:var(--v-background-base)` "
      >
        <div
          class="mb-4"
          style="font-size: 13px;"
        >
          小説を投稿するサイトの種類を設定してください。サイトによってルビの記法や、挿絵の有無が違います。
        </div>
        <v-radio-group v-model="siteType">
          <v-radio
            v-for="(n) in siteTypeList"
            :key="n.value"
            :value="n.value"
          >
            <template v-slot:label>
              <div style="font-size: 13px;">
                {{ n.label }} <span
                  v-if="n.enableimage==true"
                  class="optionItem"
                >挿絵○</span> <span
                  class="optionItem"
                >{{ createRubiFormat(n) }}</span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
    </v-container>
    <ListIcon
      style="color:var(--v-secondary-base) ;width:6px;height:7px"
      class="mr-1 mb-1 mt-4"
    />
    ルビの自動変換
    <v-switch
      v-model="autoRubiConvert"
      class="ml-4"
      label="自動変換する"
    />
    <div class="message">
      <div><v-icon>mdi-alert-box-outline</v-icon>読み込むファイルのサイズが大きい場合の注意事項</div>
      <p class="pt-2">
        ・物凄く時間が掛かる事が考えられます。スマートフォンのブラウザからだとかなり処理が遅くなる可能性があるため、推奨いたしません。
      </p>
      <p class="pl-3">
        処理の流れとしては、ファイル選択して、解析した後保存ボタンを押す事でサーバー上にアップロードされます。<br>
        保存ボタンを押すまでの間であればそのまま他の画面に移動してもサーバーには保存されません。<br>
        また、保存後<u>アプリから同期を行う場合</u>にもかなりの時間がかかる事が予想されますので、ご注意ください。
      </p>
      <p>
        ・読み込むファイルの文字数が多い場合、後から小説の投稿サイトを変更してもかなり処理が遅くなります。<br>
        インポートする時のサイトタイプにご注意ください。<br>
        間違えた場合はむしろ一旦小説を削除して再度アップロードし直したほうが早いかもしれません。
      </p>
    </div>
    <div
      class="pt-3"
      style="font-size: 13px;"
    >
      <ListIcon
        style="color:var(--v-secondary-base) ;width:6px;height:7px"
        class="mr-1"
      />
      バックアップファイルの選択
    </div>
    <div
      class="image-input mt-2 "
    >
      <div
        :class="{'over': isDragOver}"
        class="image-input__field"
        @dragleave="onDrag('leave')"
        @dragover.prevent="onDrag('over')"
        @drop.stop="onDrop"
      >
        <input
          accept="application/zip"
          title
          type="file"
          @change="inputFileList($event.target.files)"
        >
        <img
          src="../assets/ic_file.png"
          class="mr-2"
          width="80"
        >
        <span
          style="font-size:12px;"
          class="mr-2"
        >ドラッグ＆ドロップorクリックでzipファイルを選択してください。</span>
      </div>
    </div>

    <v-card-actions>
      <v-spacer />
      <div v-if="updateCount!=0 && inputFileContentUpload.length!=0">
        {{ updateCount }}/{{ inputFileContentUpload.length }}
      </div>
      <v-btn
        color="secondary"
        :disabled="progress || inputFileContents.length==0 || (saveType==0 && !name　)
          || (saveType==1 && !selectNovel)||(pageCount!=inputFileContentUpload.length) || inputFileContentUpload.length>1000"
        tile
        :loading="progress || pageCount!=inputFileContentUpload.length"
        @click="save()"
      >
        保存
      </v-btn>
    </v-card-actions>
    <div
      v-if=" inputFileContentUpload.length>1000"
      style="font-size: 13px;color:red;"
    >
      読み込んだデータの話数が1000話を超えています。<br>
      現在、大量のデータを同期した場合のアプリの動作を修正したバージョンがアップデート審査中のため、一時的に1000話までのデータのみインポート可能としております。<br>
      アプリがアップデートさえされれば解除いたしますので、今しばらくお待ちください・・・。
    </div>
    <div
      v-if="inputFileContents.length>0"
      class="pt-3"
      style="font-size: 13px;"
    >
      <ListIcon
        style="color:var(--v-secondary-base) ;width:6px;height:7px"
        class="mr-1"
      />
      読み込んだ小説一覧
    </div>
    <v-list
      v-if="inputFileContents.length>0"
      three-line
    >
      <v-list-item
        v-for="(item, index) in inputFileContents"
        :key="'story_' + index"
        three-line
      >
        <v-list-item-content>
          <v-clamp
            v-if="(item.chapter &&( index==0 || inputFileContents[index-1].chapter!=item.chapter )) "
            :max-lines="1"
            autoresize
            class="pa-0 ma-0 "
            style="font-size: 12px;color: #797979;"
          >
            {{ item.chapter }}
          </v-clamp>
          <v-list-item-title style="font-size: 13px;">
            {{ item.title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-clamp
              :max-lines="1"
              autoresize
              class="pa-0 ma-0 "
              style="font-size: 12px;color: #797979;"
            >
              {{ item.story }}
            </v-clamp>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>

import ListIcon from "@/component/svg/ListIcon";
import config from "@/const";
import Encoding from "encoding-japanese";
import JSZip from "jszip";
import VClamp from "vue-clamp";
import {mapState} from "vuex";
import firebase from "firebase";
import axios from "axios";
import rubiConverter from "@/component/rubiConverter";

export default {
  name: "NaroImport",
  components: {
    ListIcon,
    VClamp,
  },
  computed: {
    ...mapState({
      novels: state => state.NovelListModule.NovelList
    })
  },
  data() {
    return {
      isDragOver: false,
      inputFileContents: [],
      progress: false,
      autoRubiConvert: true,
      statusText: "",
      saveType: 0,
      inputLength: config.INPUT_LENGTH.novel,
      siteTypeList: config.SITE_TYPE,
      name: "",
      siteType: 0,
      selectNovel: null,
      pageCount: 0,
      updateCount: 0,
      inputFileContentUpload:[]
    }
  },
  methods: {

    onDrag(type) {
      this.isDragOver = type === "over";
    },
    onDrop(event) {
      this.isDragOver = false;
    },
    async save() {
      this.progress = true;
      try {
        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        if (token == null) {
          return
        }
        let novel;
        if (this.saveType == 0) {
          const ret = await axios.post(config.API_URL + "auth/novel", {
            "id": null,
            "modifiedTimestamp": Date.now(),
            "updateDate": Date.now(),
            "targetSite": this.siteType,
            "name": this.name,
            "createdDate": Date.now(),
          }, {
            headers: {"X-Firebase-Auth": token},
            data: {}
          })
          novel = ret.data
        } else {
          novel = this.selectNovel
        }

        let index = 0;
        let currentFolder;

        let stackUpdateItems = []

        for await (let file of this.inputFileContentUpload) {
          if (!file.saved) {
            const folder = await this.updateFolderIfNeeded(novel, file, index, token)

            const saveData = await this.saveFile(novel, file, folder)
            saveData.index = index
            stackUpdateItems.push(saveData)

            if ((currentFolder && folder != currentFolder) || stackUpdateItems.length > 9 || index === this.inputFileContentUpload.length - 1) {
              await axios.post(config.API_URL + "auth/pages", stackUpdateItems, {
                headers: {"X-Firebase-Auth": token},
              })
              stackUpdateItems.forEach(value => {
                this.inputFileContentUpload[value.index].saved = true
                this.updateCount++;
              })
              stackUpdateItems = []
            }
            currentFolder = folder
          }
          index++;

        }
      } catch (e) {
        alert("データの保存・作成中にエラーが発生しました。中途半端にデータが作成されている可能性があるため、一度ご確認ください。")
      }

      this.progress = false;
      if (this.updateCount == this.pageCount) {
           this.$router.back()
      } else {
        alert("一部保存できなかったコンテンツがあります。再度保存を押して、途中から再開ができます。")
      }
    },
    readFileAsync(file, index) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = (e) => {
          reject()
        };
        reader.readAsArrayBuffer(file);
      })
    },
    createRubiFormat(siteConfig) {
      if (siteConfig.rubiFormat) {
        return `${siteConfig.rubiFormat.prefix}ルビ${siteConfig.rubiFormat.middle}ルビ${siteConfig.rubiFormat.suffix}`
      } else {
        return `ルビ無し`
      }

    },
    async updateFolderIfNeeded(novel, contents, index, token) {
      let folder;
      const chapter = contents.chapter
      if ((index == 0 && chapter) || (chapter && this.inputFileContentUpload[index - 1].chapter !== chapter)) {
        //フォルダを新規作成する
        const newFolder = {
          novelId: novel.id,
          createdDate: Date.now(),
          folderId: -1,
          updateDate: Date.now(),
          modifiedTimestamp: Date.now(),
          name: chapter
        }
        const ret = await axios.post(config.API_URL + "auth/folder", newFolder, {
          headers: {"X-Firebase-Auth": token, "fromWeb": false},
        })
        folder = ret.data
        contents.folder = folder;
      } else if (index != 0 && this.inputFileContentUpload[index - 1].chapter === chapter && this.inputFileContentUpload[index - 1].folder) {
        folder = this.inputFileContentUpload[index - 1].folder
        contents.folder=folder;
      }
      return folder
    },
    async saveFile(novel, contents, folder) {
      const saveData = {
        createdDate: Date.now(),
        novelId: novel.id,
        folderId: folder ? folder.id : -1,
        modifiedTimestamp: Date.now()
      }
      saveData.updateDate = Date.now()
      saveData.name = contents.title
      saveData.content = this.rubiConverterIfNeeded(novel, contents.story)
      saveData.new = true
      return saveData
    },

    async inputFileList(fileList) {
      // event.target.filesはファイルデータが格納されたリストです
      if (fileList.length == 0) {
        return
      }
      this.progress = true;
      const jsZip = new JSZip();
      const zip = await jsZip.loadAsync(fileList[0]);

      var matchFile

      zip.forEach((relativePath, file) => {

        const match = /.*([nN][a-zA-Z0-9]+)\.txt/g.exec(file.name)
        if (match) {
          matchFile = file
        }
      });
      if (matchFile) {
        const value = await matchFile.async("text")
        try {
          this.calcNovel(value)
        } catch (e) {
          alert("ファイルの解析中にエラーが発生しました。ファイル形式が不正な可能性があります。")
        }
      } else {
        alert("ファイルの解析中にエラーが発生しました。ファイル形式が不正な可能性があります。")
      }
      this.progress = false;
    },

    calcNovel(text) {
      const encodeText = text
      const title = /【タイトル】(.*)【作者名】/gs.exec(encodeText)[1].replaceAll("\n", "")
      const mainTextArea = encodeText.split(/評価平均: [\d\\.]+pt\r\n\r\n/gms)[1]
      const storyExec = mainTextArea.split(/------------------------- 第\d+部分開始 -------------------------/gms)
      let chapter = null
      const stories = []
      storyExec.forEach(storyBlock => {
        if (storyBlock.length != 0) {
          const chapterExec = /【第\d+章】(.*)【サブタイトル】/gms.exec(storyBlock.toString())
          if (chapterExec) {
            chapter = chapterExec[1].replaceAll("\r\n","")
          }
          const subTitleExec = /【サブタイトル】\r\n(.*)\r\n\r\n【/g.exec(storyBlock.toString())
          let subTitle = title;
          if (subTitleExec) {
            subTitle = subTitleExec[1].replaceAll("\r\n","")
          }
          const story = /【本文】(.*)/gms.exec(storyBlock.toString())[1]
              .replace(/\r\n\r\n【免責事項】.*/gms, "")
              .replace(/\r\n\r\n【後書き】.*/gms, "")

          const storyObj = {
            chapter: chapter,
            title: subTitle,
            story: story
          }
          stories.push(storyObj)
          this.pageCount++;
        }
      })
      this.inputFileContentUpload=stories;
      this.inputFileContents = []
      const list = this.inputFileContents
      const ite = function* () {
        // NOTE: 1アイテムづつsetTimeoutでレンダリング
        for (let len = stories.length, i = 0; i < len; i++) {
          yield setTimeout(() => {
            const item = stories[i]; // Get items one by one
            list.push(item);
            ite.next();
          });
        }
      }();
      ite.next();
    },
    encodeText(text) {
      const codes = new Uint8Array(text);
      const encoding = Encoding.detect(codes);

      // Convert encoding to unicode
      let unicodeString = text
      if (encoding) {
        unicodeString = Encoding.convert(codes, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        });
      }
      unicodeString = unicodeString.replaceAll("&amp;", "&")
          .replaceAll("&#x27", "'")
          .replaceAll("&#x60", '`')
          .replaceAll('&quot;', '"')
          .replaceAll('&lt;', '<')
          .replaceAll('&gt;:', '>')

      return unicodeString;
    },
    rubiConverterIfNeeded(novel, text) {
      if (this.autoRubiConvert) {
        return rubiConverter.convert(0,novel.targetSite,text)
      } else {
        return text
      }
    },


  }
}
</script>

<style scoped>

.image-input {
  height: 130px;
  width: 100%;
  background-color: var(--v-background-base);
}

.image-input__field {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-input__field.over {
  background-color: #666;
}

.image-input__field > input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.image-input__field > p {
  color: #aaa;
  text-align: center;
}

.optionItem {
  margin-left: 6px;
  padding: 2px;
  font-size: 10px;
  letter-spacing: 2px;
  background-color: #7D7D7D;
  color: #FFFFFF;
}

.message {
  border: var(--v-background-base) solid 1px;
  margin: 12px;
  padding: 12px 8px 0px;
  font-size: 13px;
}
</style>